/** 设备监控 → 趋势图 指标定义 */

import { allDeviceMetrics, deviceMetricByKey, getDeviceTypeMetrics } from '@/config/deviceTypeMetrics'

const LEGACY_METRIC_ALIASES = [
  { key: 'inletLeak', label: '进口泄漏', unit: 'LEL%' },
  { key: 'concentration', label: '泄漏浓度', unit: 'LEL%' },
  { key: 'batteryVoltage', label: '电池电压', unit: 'V' },
  { key: 'batteryMonths', label: '电池可使用月数', unit: '月' }
]

export const DEVICE_TREND_METRICS = allDeviceMetrics().concat(LEGACY_METRIC_ALIASES)

export function trendMetricsForDeviceType(deviceType) {
  return getDeviceTypeMetrics(deviceType)
}

export function metricByKey(key) {
  return deviceMetricByKey(key) || DEVICE_TREND_METRICS.find(m => m.key === key) || DEVICE_TREND_METRICS.find(m => m.key === 'stdInstant') || DEVICE_TREND_METRICS[0]
}

export function goDeviceTrend(router, { deviceId, deviceCode, deviceName, terminalCode, terminalName, metric, terminalType, protocolId, protocolName }) {
  router.push({
    path: '/device/trend',
    query: {
      deviceId: deviceId || '',
      deviceCode: deviceCode || '',
      deviceName: deviceName || '',
      terminalCode: terminalCode || '',
      terminalName: terminalName || '',
      metric: metric || 'stdInstant',
      terminalType: terminalType || '',
      protocolId: protocolId || '',
      protocolName: protocolName || ''
    }
  })
}
